// utils/medication.ts
import type { Medication } from '../types/medication';

export const generateOrderNumber = (): string => {
  return `ORD-${new Date().getFullYear()}-${String(Date.now()).slice(-6)}`;
};

export const validateMedication = (medication: Partial<Medication>): boolean => {
  return Boolean(medication.name?.trim());
};

export const formatMedicationSummary = (medication: Medication): string => {
  return `${medication.name} - ${medication.dose} ${medication.doseUnit} ${medication.frequency} ${medication.interval}`;
};
